var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.showInModal,
          expression: "!showInModal"
        }
      ],
      class: _vm.bemBlock,
      attrs: { "data-context": _vm.context }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.sizes.length > 1,
              expression: "sizes.length > 1"
            }
          ],
          class: _vm.bemElement("sizes")
        },
        _vm._l(_vm.sizes, function(size) {
          return _c(
            "span",
            {
              key: size.id,
              class: [
                _vm.bemElement("size", {
                  "no-sale": _vm.isMarketWithoutSale,
                  disabled: _vm.isDisabled(size),
                  selected: _vm.isChecked(size)
                })
              ]
            },
            [
              _c("input", {
                ref: "productTileSizeSelectorInput" + _vm.pidsize(size),
                refInFor: true,
                class: _vm.bemElement("size-input", {
                  disabled: _vm.isDisabled(size)
                }),
                attrs: {
                  id: _vm.pidsize(size),
                  type: "radio",
                  name: "product_size",
                  disabled: _vm.isDisabled(size),
                  "data-attr-url": size.url
                },
                domProps: { value: size.value, checked: _vm.isChecked(size) },
                on: {
                  click: function($event) {
                    return _vm.handleSizeChange($event, size)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { class: ["size-box", { "is-strike": _vm.isDisabled(size) }] },
                [
                  _c(
                    "label",
                    {
                      class: _vm.bemElement("size-label"),
                      attrs: { for: _vm.pidsize(size) }
                    },
                    [
                      _vm.isDisabled(size)
                        ? _c("s", [
                            _vm._v(
                              "\n            " +
                                _vm._s(size.displayValue) +
                                "\n          "
                            )
                          ])
                        : [
                            _vm._v(
                              "\n            " +
                                _vm._s(size.displayValue) +
                                "\n          "
                            )
                          ]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "strike" })
                ]
              )
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }